export enum Role {
  USER = 'user',
  INTERNAL = 'internal',
  ADMIN = 'admin',
}

export enum Source {
  LOCAL = 'local',
  GOOGLE = 'google',
  AZURE = 'azure',
}

export const emailAlreadyExistsMessage = 'Email already exists.';
export const userNotFoundMessage = 'User not found.';
export const localUserNotFound = 'Local user not found.';
export const incorrectPasswordMessage = 'Incorrect password.';
export const missingDropboxLinkMessage = 'Missing dropbox link.';
export const emailIsNotConfirmedMessage = 'Email is not confirmed.';
export const userNameAlreadyExistsMessage = 'User name already exists.';
export const noAccessToJobMessage = 'No access to job.';
